import { Directive } from '@angular/core';

@Directive({
  selector: 'xpo-empty-state-header',
})
export class XpoEmptyStateHeader {}
